import React, { useState, MouseEvent } from 'react'
import { IconButton, Menu, MenuItem, Box } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { UserEntity } from '@finance-lab/utils/types'

function UserActionsMenu({
    user,
    onSetUserCategory,
    onDisconnectClick,
    onToggleDisabled,
    onDeleteUser,
    onChangePassword,
}: {
    user: UserEntity
    onSetUserCategory?: (user: UserEntity) => void
    onDisconnectClick?: (user: UserEntity) => void
    onToggleDisabled?: (id: string | number, disabled: boolean) => void
    onDeleteUser?: (id: string | number) => void
    onChangePassword?: (user: UserEntity) => void
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
    const handleMenuClose = () => setAnchorEl(null)

    return (
        <Box sx={{ display: 'flex', justifyContent: 'left', width: '100%', minHeight: 40 }}>
            <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                {onSetUserCategory && (
                    <MenuItem
                        onClick={() => {
                            onSetUserCategory(user)
                            handleMenuClose()
                        }}
                    >
                        Ändra kategori
                    </MenuItem>
                )}
                {user.customerName && onDisconnectClick && (
                    <MenuItem
                        onClick={() => {
                            onDisconnectClick(user)
                            handleMenuClose()
                        }}
                    >
                        Koppla loss
                    </MenuItem>
                )}
                {onToggleDisabled && (
                    <MenuItem
                        onClick={() => {
                            onToggleDisabled(user.id, user.disabled)
                            handleMenuClose()
                        }}
                    >
                        {!user.disabled ? 'Inaktivera' : 'Aktivera'}
                    </MenuItem>
                )}
                {onDeleteUser && (
                    <MenuItem
                        onClick={() => {
                            onDeleteUser(user.id)
                            handleMenuClose()
                        }}
                    >
                        Ta bort
                    </MenuItem>
                )}
                {!user.disabled && onChangePassword && (
                    <MenuItem
                        onClick={() => {
                            onChangePassword(user)
                            handleMenuClose()
                        }}
                    >
                        Lösen
                    </MenuItem>
                )}
            </Menu>
        </Box>
    )
}

export default UserActionsMenu
